// extracted by mini-css-extract-plugin
export default {"root":"CompleteProfileModal_root__c+ly+","mainLink":"CompleteProfileModal_mainLink__tM2RM buttonPrimary"};